// extracted by mini-css-extract-plugin
export var directoryCarImg = "carDetails-module--directoryCarImg--ib9Fh";
export var images = "carDetails-module--images--3YAEN";